<section
    *ngIf="wire"
    class="agpr-wireReport"
>
    <div
        class="agpr-wireReport-centerWrapper"
        [ngClass]="{'agpr-wireReport-centerWrapper--fullWidth': selectedTabIndex === wireReportTypes.performance}"
    >
        <div class="agpr-wireReport-center">
            <header>
                <h2 class="u-srOnly">{{ 'Amplify.wireReport.header' | localize }}</h2>
            </header>
            <div class="agpr-wireReport-center-toolbar">
                <agpr-tabs
                    class="agpr-wireReport-center-tabs"
                    [selectedTabIndex]="selectedTabIndex"
                    [style]="tabsStyleTypes.icon"
                    (selectedTabIndexChange)="tabChange($event)"
                >
                    <agpr-tab
                        [icon]="' fa-gauge-simple-high'"
                        [heading]="'Amplify.wireReport.toolbar.performance'"
                        [id]="'wireReport.performanceTab'"
                    ></agpr-tab>
                    <agpr-tab
                        [icon]="'fa-kit fa-agpr-compose'"
                        [heading]="'Amplify.wireReport.toolbar.composition'"
                        [id]="'wireReport.compositionTab'"
                    ></agpr-tab>
                </agpr-tabs>
            </div>
            <agpr-scroll-panel>
                <div class="agpr-wireReport-center-report">
                    <agpr-wire-performance-report
                        *ngIf="selectedTabIndex === wireReportTypes.performance"
                    ></agpr-wire-performance-report>
                    <agpr-wire-composition-report
                        *ngIf="selectedTabIndex === wireReportTypes.composition"
                    ></agpr-wire-composition-report>
                </div>
            </agpr-scroll-panel>

            <agpr-action-bar *ngIf="selectedTabIndex === wireReportTypes.performance && !!performanceReport">
                <ng-template #right>
                    <agpr-button
                        label="Amplify.wireReport.export.button"
                        (click)="exportReport()"
                    ></agpr-button>
                </ng-template>
            </agpr-action-bar>
        </div>
    </div>

    <aside [ngClass]="selectedTabIndex === wireReportTypes.performance ? 'agpr-wireReport-sidebar--collapsed' : 'agpr-wireReport-sidebar'">
        <agpr-right-sidebar
            #rhp
            [collapsible]="selectedTabIndex === wireReportTypes.performance"
            [overlayContainer]="overlayContainer"
            [(selectedTabIndex)]="rhpSelectedTabIndex"
        >
            <agpr-tab
                icon=" fa-file-lines"
                tooltip="Amplify.wireReport.rhp.releaseDetails"
                [id]="'wireReport.releaseDetailsTab'"
            >
                <div class="agpr-releaseDetails-name">
                    {{ wire.name }}
                </div>

                <div class="agpr-releaseDetails-general">
                    <agpr-attribute-list
                        [attributes]="wireAttributes"
                    ></agpr-attribute-list>
                </div>

                <ng-container *ngIf="wire.regions?.length > 0">
                    <div class="agpr-releaseDetails-label">{{'Amplify.wire.publicationRegions' | localize}}</div>
                    <div *ngFor="let region of wire.regions; let last = last">
                        {{'WireRegion.' + region | localize}}{{ !last ? ', ' : ''}}
                    </div>
                </ng-container>

                <ng-container *ngIf="wire.seoKeywords?.length > 0">
                    <div class="agpr-releaseDetails-label">{{'Amplify.wire.categories.seoKeywords' | localize}}</div>
                    <div *ngFor="let keyword of wire.seoKeywords; let last = last">
                        {{keyword}}{{ !last ? ', ' : ''}}
                    </div>
                </ng-container>

                <div class="agpr-releaseDetails-label">{{'Amplify.wire.editorialContactCommunication' | localize}}</div>
                <div class="agpr-releaseDetails-value">{{wire.contactName}}</div>
                <div class="agpr-releaseDetails-value">{{wire.contactEmail}}</div>
            </agpr-tab>

            <agpr-tab
                icon=" fa-sticky-note"
                tooltip="Amplify.wire.editorialCommunication"
                [id]="'wireReport.editorialCommunicationTab'"
            >
                <div class="agpr-releaseDetails-name">
                    {{ wire.name }}
                </div>
                <div class="agpr-releaseDetails-label">{{ 'Amplify.wireReport.rhp.editorialCommunication.notes' | localize }}</div>

                <agpr-user-notes
                    [id]="'wireReport_userNotes'"
                    [userNotes]="wire?.userNotes"
                    [scrolling]="false"
                    [readonly]="true"
                ></agpr-user-notes>
            </agpr-tab>
        </agpr-right-sidebar>
    </aside>
</section>
